import Dialog from "@material-ui/core/Dialog";
import React, { useEffect, useState } from "react";
import {
  CloseButton,
  FormTitle,
  SmallTitleText,
  StyledPaper,
} from "../../../underwriterDashboard/idpDocuments/styles";
import CloseIcon from "@material-ui/icons/Close";
import { FunctionalButton } from "../../../../components/functionalButton";
import PledgxLogo from "../../../../assets/common/pledgxLogo";
import styled from "styled-components";
import { AlertPopup } from "../../../../components/alertPopup/alertPopup";

export const ConsolidatePopup = ({
  open,
  setOpen,
  companyName,
  subsidiaries,
  onConfirm,
}) => {
  console.log("Subs: ", subsidiaries);

  const [data, setData] = useState([]);

  useEffect(() => {
    if (subsidiaries) {
      subsidiaries.forEach((subsidiary) => {
        subsidiary.selected = false;
      });
      setData(subsidiaries);
    }
  }, [subsidiaries]);

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={React.Fragment}
      maxWidth={"xl"}
    >
      <StyledPaper elevation={0}>
        <CloseButton
          onClick={() => {
            setOpen(false);
          }}
        >
          <CloseIcon />
        </CloseButton>
        <PledgxLogo />

        <FormTitle
          style={{
            marginTop: "30px",
            marginBottom: "5px",
            color: "#1A051D",
            fontSize: "22px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "24px",
            textAlign: "center",
          }}
        >
          Consolidate Data
        </FormTitle>

        <SmallTitleText style={{ marginBottom: "14px" }}>
          {companyName}
        </SmallTitleText>

        {data && (
          <SubsidiaryTable subsidiaryData={data} setSubsidiaryData={setData} />
        )}
      </StyledPaper>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FunctionalButton
          buttonTitle="Close"
          handleButton={() => {
            setOpen(false);
          }}
          width="308px"
          height="48px"
          isReversedColor={true}
          marginRight={"48px"}
          marginLeft={"48px"}
          marginTop={"30px"}
          marginBottom={"20px"}
          fontSize={"18px"}
          disabled={false}
          icon={null}
          hasBoxShadow={true}
          frontIcon={null}
          weight={600}
        />
        <FunctionalButton
          buttonTitle="Consolidate"
          handleButton={() => {
            setOpen(false);
            onConfirm(data.filter((row) => row.selected));
          }}
          width="308px"
          height="48px"
          isReversedColor={false}
          marginRight={"48px"}
          marginLeft={"48px"}
          marginTop={"30px"}
          marginBottom={"20px"}
          fontSize={"18px"}
          // disabled={data.every((d) => !d.selected)}
          icon={null}
          hasBoxShadow={true}
          frontIcon={null}
          weight={600}
        />
      </div>
    </Dialog>
  );
};

const TableContainer = styled.div`
  width: 100%;
  min-width: 700px;
  padding: 16px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  tr {
    color: #6b7280;
    font-weight: bold;
  }

  th:first-child {
    border-top-left-radius: 5px;
  }

  th:last-child {
    border-top-right-radius: 5px;
  }
`;

const HeaderCell = styled.th`
  text-align: left;
  padding: 16px;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border: 1px solid #ebe9f1;
  background-color: white;
  color: #6e6b7b;
  border-radius: 5px;
`;

const TableCell = styled.td`
  padding: 12px 16px;
`;

// Custom checkbox wrapper
const CheckboxWrapper = styled.label`
  display: inline-block;
  position: relative;
  cursor: pointer;
  user-select: none;
`;

// Hidden native checkbox
const NativeCheckbox = styled.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

// Custom checkbox visual
const CustomCheckbox = styled.span`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: ${(props) => (props.checked ? "#ff6d1d" : "#f26934")};
  border-radius: 3px;

  &:after {
    content: "";
    position: absolute;
    display: ${(props) => (props.checked ? "block" : "none")};
    left: 5px;
    top: 2px;
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const SubsidiaryTable = ({ subsidiaryData, setSubsidiaryData }) => {
  console.log("Sub Data: ", subsidiaryData);

  const [showMultipleDatesPopup, setShowMultipleDatesPopup] = useState(false);

  const toggleSelect = (index) => {
    const dates = subsidiaryData
      .filter((data) => data.selected)
      .map((data) => data.statementDate);

    if (
      !dates.includes(subsidiaryData[index].statementDate) &&
      dates.length > 0
    ) {
      setShowMultipleDatesPopup(true);
    }

    const newData = [...subsidiaryData];
    newData[index].selected = !newData[index].selected;
    setSubsidiaryData(newData);
  };

  return (
    <>
      <AlertPopup
        headerText="Multiple Reporting Dates Selected"
        height="434px"
        subHeaderText="Financial data for each reporting date will be consolidated separately for that reporting date."
        openPopup={showMultipleDatesPopup}
        setOpenPopup={setShowMultipleDatesPopup}
        showIcon={true}
        width={"640px"}
        showButton={false}
      />
      <TableContainer>
        <Table>
          <TableHeader>
            <tr>
              <HeaderCell>Subsidiary Name</HeaderCell>
              <HeaderCell>Subsidiary ID</HeaderCell>
              <HeaderCell>Reporting Date</HeaderCell>
              <HeaderCell>Select Option</HeaderCell>
            </tr>
          </TableHeader>
          <TableBody>
            {subsidiaryData?.map((row, index) => (
              <TableRow key={`${row.subsidiaryID}-${index}`}>
                <TableCell>{row.subsidiaryName}</TableCell>
                <TableCell>{row.subsidiaryID}</TableCell>
                <TableCell>{row.statementDate}</TableCell>
                <TableCell>
                  <CheckboxWrapper>
                    <NativeCheckbox
                      checked={row.selected}
                      onChange={() => toggleSelect(index)}
                    />
                    <CustomCheckbox checked={row.selected} />
                  </CheckboxWrapper>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
